import { render } from "./ToggleButtons.vue?vue&type=template&id=28076759"
import script from "./ToggleButtons.vue?vue&type=script&lang=js"
export * from "./ToggleButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__